import api from "./api";

export const startSurvey = (slug) =>
  api.post(`/survey/${slug}/start`);

export const getOptions = (slug, parentId) =>
  api.get(`/survey/${slug}/options`, {
    params: parentId ? { parentId } : {},
  });

export const selectOption = (slug, nodeId, stepNo) =>
  api.post(`/survey/${slug}/select`, { nodeId, stepNo });